/* eslint-disable no-undef */
/* globals _BEVY_SETTINGS_ */
import _isObject from 'lodash/isObject';

let bevySettings = {};

if (typeof _BEVY_SETTINGS_ !== 'undefined') {
  bevySettings = _BEVY_SETTINGS_;
}

bevySettings.globals = {};
if (typeof Globals !== 'undefined' && _isObject(Globals)) {
  bevySettings.globals = Globals;
}

export const settings = bevySettings;
